import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import HistoryIcon from "@mui/icons-material/History";

import { getStyles } from "src/styles/theme";
import defaultStyles from "./styles";

export type DashBoardTable = {
  topHeader: string[];
  data: any;
  /**
   * Both are optional so the read-only usages of this table (Final Submitted
   * Details) keep rendering exactly as before. The Actions column only appears
   * when at least one of them is supplied.
   */
  onEdit?: (row: any) => void;
  onViewHistory?: (row: any) => void;
};

export function MonitoringMemberDetailsTable({
  data,
  topHeader,
  onEdit,
  onViewHistory,
}: DashBoardTable) {
  const styles = getStyles(defaultStyles);

  const showActions = Boolean(onEdit || onViewHistory);

  return (
    <TableContainer
      component={Paper}
      sx={{ height: "fit-content", mt: "20px" }}
    >
      <Table sx={{ minWidth: 600 }} aria-label="simple table">
        <TableHead {...styles("header")}>
          <TableRow>
            {topHeader.map((item, index) => (
              <TableCell align="center" {...styles("cell")} key={index}>
                {item}
              </TableCell>
            ))}
            {showActions && (
              <TableCell align="center" {...styles("cell")}>
                Actions
              </TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {data &&
            data.length > 0 &&
            data.map((item, index) => {
              if (!item) return null;
              return (
                <TableRow key={index}>
                  <TableCell
                    align="center"
                    {...styles("cell", { width: "30px" })}
                  >
                    {index + 1}
                  </TableCell>
                  <TableCell
                    align="center"
                    {...styles("cell", { width: "100px" })}
                  >
                    {item.name}
                  </TableCell>
                  <TableCell
                    align="center"
                    {...styles("cell", { width: "100px" })}
                  >
                    {item.designation}
                  </TableCell>
                  <TableCell
                    align="center"
                    {...styles("cell", { width: "100px" })}
                  >
                    {item.phoneNumber}
                  </TableCell>
                  <TableCell
                    align="center"
                    {...styles("cell", { width: "100px" })}
                  >
                    {item.email}
                  </TableCell>
                  {showActions && (
                    <TableCell
                      align="center"
                      {...styles("cell", { width: "110px" })}
                    >
                      {/* isEditable is decided by the API: only the user who
                          added this member may change it. */}
                      {onEdit && item.isEditable && (
                        <Tooltip title="Edit member">
                          <IconButton
                            aria-label="edit member"
                            onClick={() => onEdit(item)}
                          >
                            <EditIcon />
                          </IconButton>
                        </Tooltip>
                      )}
                      {onViewHistory && (
                        <Tooltip title="View update history">
                          <IconButton
                            aria-label="view update history"
                            onClick={() => onViewHistory(item)}
                          >
                            <HistoryIcon />
                          </IconButton>
                        </Tooltip>
                      )}
                    </TableCell>
                  )}
                </TableRow>
              );
            })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
